import {
  BulkEquipmentAssignmentCommand,
  EquipmentsApi,
  EquipmentType,
} from '@operations/app/api'
import { createApiClient } from '@operations/app/http-client'

class EquipmentService {
  httpClient = createApiClient(EquipmentsApi)

  async loadEquipmentTypes() {
    const { data } = await this.httpClient.getEquipmentTypes()

    return data
  }

  async load(props?: {
    includeInactive?: boolean
    equipmentType?: EquipmentType
    vesselVisitId?: number
  }) {
    const { data } = await createApiClient(EquipmentsApi).get(
      props?.vesselVisitId,
      props?.equipmentType,
      props?.includeInactive,
    )

    return data
  }

  async loadPlanned(carrierVisitId: number, includeInactive = true) {
    const { data } = await this.httpClient.getPlanned(carrierVisitId, includeInactive)

    return data
  }

  async getAssignedCranesForContainers(carrierVisitId: number) {
    const { data } = await this.httpClient.getAssignedCranesForContainersByVisit(carrierVisitId)

    return data
  }

  async builkAssignment(bulkEquipmentAssignment: BulkEquipmentAssignmentCommand) {
    await this.httpClient.bulkEquipmentAssignmentCommand(bulkEquipmentAssignment)
  }

  async updateEquipmentResponsibleUser(equipmentId: number, userId: string) {
    await this.httpClient.updateEquipmentResponsibleUser({
      id: equipmentId,
      userId,
    })
  }

  async logoutOperatorEquipment(userId: string) {
    await this.httpClient.logoutOperatorEquipment({
      userId,
    })
  }

  async getOperationalEquipments(ids: number[] = []) {
    const { data } = await this.httpClient.getOperationalEquipments(ids)

    return data
  }

  async getLastInteractionById(id: number) {
    const { data } = await this.httpClient.getLast(id)

    return data
  }
}

const equipmentService = new EquipmentService()

export default equipmentService
